// STYLE
import './_meet-the-team.scss'
import {get} from 'lodash/fp'

// LIBS
import React from 'react'

// DATA
let teamMembers = require('../../data/code/team-members.json').map(item => ({...item, order: item.order || 100})).sort((a, b) => a.order - b.order)

// COMPONENTS
import MetaData from '../../components/meta-data'

let TeamMemberItem = (teamMember, i) => {
  let imageURL = get('image.fields.file.url', teamMember)
  return (
    <li key={i}>
      <article className="cell" href="#">
        <img className="img" src={imageURL} alt={teamMember.name} />
        <span className="text">
          <div className="primary-info">
            <h2 className="name">{teamMember.name}</h2>
            <h3 className="title">{teamMember.jobTitile}</h3>
          </div>
          <div className="about">
            <p><strong>At Code Fellows, I: </strong>{teamMember.responsibility}</p>
            <p><strong>Students can talk to me about: </strong>{teamMember.studentsCanTalkToMeAbout}</p>
          </div>
        </span>
      </article>
    </li>
  )
}

// INTERFACE
const TeamPage = () => {
  return (
    <div>
      <MetaData data={{
        title: 'Meet Our Team of Coders, Developers & More | Code Fellows',
        description: 'Meet the Code Fellows team',
        slug: 'meet-the-team',
      }} />
      <div className="custom-page-header team-page-header" >
        <h1>Meet the Team</h1>
      </div>
      <div className="row team-page">
        <div className="profiles">
          <ul className="staff-profile">
            {teamMembers.map(TeamMemberItem)}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default TeamPage



// WEBPACK FOOTER //
// ./src/pages/meet-the-team/index.js